import CommonContainer from "../../Container/CommonContainer";
import { FaToggleOn, FaToggleOff, FaPen } from "react-icons/fa";
import * as SR_TypeService from "../../../Services/Masters/SR_Type/SR_TypeService";
import toast from "react-hot-toast";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";

const SR_TypeComponent = () =>{

    const { register, handleSubmit, formState: { errors }, reset, } = useForm();

    const [caseOriginList, setSR_TypeList] = useState([]);
    const [selectedSR_Type, setSelectedSR_Type] = useState({});
    const [newSR_TypeModal, setNewSR_TypeModal] = useState(false);

    const fetchAllSR_TypeMasterList = () => {
        SR_TypeService.GetSR_TypeList()
          .then(({ data }) => {
            if (data.IsSuccess) {
              setSR_TypeList(data.Data);
            }
            else{
              setSR_TypeList([]);
              toast.error("Something went wrong.")
            }
          })
          .catch(() => toast.error("Something went wrong."));
    };

    useEffect(() => {
        fetchAllSR_TypeMasterList();
        if (caseOriginList.length > 0) {
          //console.log("Updated caseOriginList:", caseOriginList);
        }
    },[]);

    const onSubmit = (data) => {
      //debugger;
      if (selectedSR_Type?.SrId) {
        data.SrId = selectedSR_Type?.SrId;
        SR_TypeService.UpdateSR_Type(data)
          .then(({ data }) => {
            if (data.IsSuccess) {
              fetchAllSR_TypeMasterList();
              toast.success("SR Type updated successfully!");
              handleNewSR_TypeModalClose();
            } else {
              toast.error("Something went wrong during update.");
            }
          })
          .catch(() => toast.error("Something went wrong during update."))
          .finally(() => { });
      } else {
        SR_TypeService.CreateNewSR_Type(data)
          .then(({ data }) => {
            if (data.IsSuccess) {
              fetchAllSR_TypeMasterList();
              toast.success("SR Type saved successfully!");
              handleNewSR_TypeModalClose();
            } else {
              toast.error(data.ResponseMessage);
            }
          })
          .catch(() => toast.error("Something went wrong during creation."))
          .finally(() => { });
      }
    };

    const handleNewSR_TypeModalClose = () => {
      reset();
      setSelectedSR_Type([]);
      setNewSR_TypeModal(false)
    };

    const handleActivateDeActivateSR_Type = (rec) =>{
      SR_TypeService.ActivateDeActivateSR_Type(rec.SrId, !rec.IsActive).then(data => {
        if (data.data.IsSuccess) {
          const message = rec.IsActive ? "SR Type DeActivated Successfully" : "SR Type Activated Successfully";
          toast.success(message);
          fetchAllSR_TypeMasterList();
        } else {
          toast.error("Somthing went wrong");
        }
        //console.log("data", data)
      }).catch(error => {
        toast.error("Somthing went wrong");
      })
    }

    const handleViewSR_TypeDetailById = (SrId) => {
      //debugger;
      const selectedItem = caseOriginList.find(item => item.SrId === SrId);
      if(selectedItem != null){
        setSelectedSR_Type(selectedItem);
        setNewSR_TypeModal(true);
      }
      else{
        selectedSR_Type({});
      }
    };

    return (
        <>
          {/* <LoadingSpinnerComponent></LoadingSpinnerComponent> */}
          <CommonContainer heading="SR Type List" buttonText="Add SR Type" onButtonClick={() => { reset(); setSelectedSR_Type([]); setNewSR_TypeModal(true) }}>
    
            <div className="d-flex align-items-center justify-content-between mb-2">
              <div className="d-flex align-items-center gap-2">
              </div>
              {/* <div className="search-box" style={{ position: "relative", width: "320px" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  //ref={selectedSearchUser}
                  style={{
                    paddingRight: "35px",
                    borderRadius: "5px",
                    border: "1px solid #ddd",
                  }}
                />
                <button
                  type="button"
                  className="btn btn-success d-flex align-items-center justify-content-center"
                  style={{
                    padding: '5px',
                    position: "absolute",
                    right: "0px",
                    height: "35px",
                    width: "45px",
                    top: "50%",
                    borderTopLeftRadius: "0",
                    borderBottomLeftRadius: "0",
                    transform: "translateY(-50%)",
                  }}
                  //onClick={fetchUniversalFilterUserData}
                >
                  <FaSearch />
                </button>
    
              </div> */}
            </div>
            <div>
              <div className="table-responsive" >
                <table className="table table-bordered custom-table" >
                  <thead>
                    <tr>
                      <th> SR Type</th>
                      <th> Active </th>
                      <th> Action </th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      caseOriginList.length > 0 ? (
                        caseOriginList.map((rec, index) => (
                          <tr key={index} >
                            <td>{rec.TypeName}</td >
                            <td>
                              {rec.IsActive ? <FaToggleOn title="Deactivate SR_Type" onClick={() => handleActivateDeActivateSR_Type(rec)} color="green" size={16} /> : <FaToggleOff onClick={() => handleActivateDeActivateSR_Type(rec)} title="Activate SR_Type" color="red" size={16} />}
                            </td>
                            <td>
                              {/* <FaPenSquare color="green" className="mr-2 cursor-pointer" size={25} onClick={() => handleViewUserDetailById(rec.UserId)} title="Edit User" /> */}
                              <FaPen color="green" className="mr-2 cursor-pointer" onClick={() => handleViewSR_TypeDetailById(rec.SrId)} title="Edit SR_Type" />
                              {/* <FaTrash color={"red"} onClick={() => handleUserDelete(rec)} /> */}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr><td colSpan="9" className="text-center" > No Data found </td></tr >
                      )}
                  </tbody>
                </table>
              </div>
            </div>

            {newSR_TypeModal && (
            <div className="modal-backdrop">
              <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg custom-modal" role="document">
                  <div className="modal-content mb-0 p-0">
                    <div className="modal-header p-2-5">
                      <h5 className="modal-title">{selectedSR_Type?.SR_Type ? "Edit SR Type" : "New SR Type"}</h5>
                      <button type="button" className="btn-close" onClick={handleNewSR_TypeModalClose}></button>
                    </div>
                    <div className="modal-body p-1">
                      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                        <div className="container mb-0" style={{ fontSize: "13px" }}>

                          <div className="row">

                            <div className="col-md-4 mb-2">
                              <label className="fw-bold required mb-0-5">SR Type</label>
                              <input type="text" className="form-control" placeholder="Enter SR Type" {...register("TypeName", { required: "SR Type is required" })} defaultValue={selectedSR_Type?.TypeName || ""} />
                              {errors.SR_Type && <p className="text-danger required_error">{errors.SR_Type.message}</p>}
                            </div>
                          </div>
                        </div>

                        <div className="modal-footer mt-0 mb-0 pt-1 pb-0 pr-1">
                          <button type="button" className="btn btn-danger" onClick={handleNewSR_TypeModalClose}>Close</button>
                          <button type="submit" className="btn btn-primary">{selectedSR_Type?.SrId ? "Update" : "Save"}</button>
                        </div>

                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
    
          </CommonContainer >
        </>
      );
}

export default SR_TypeComponent